import { api } from "../../../config/api";

export const loginApi = async (username, password) => {
  return await api.post("/api/auth/login", { username, password });
};

export const getMeApi = async (token) => {
  return await api.get("/api/auth/me", {
    headers: { Authorization: `Bearer ${token}` },
  });
};
